// extracted by mini-css-extract-plugin
export var tosLink = "_bs-0";